import { ISSUETYPE_FIELDKEY } from '@atlassian/jira-polaris-domain-field/src/field/constants.tsx';
import { FIELD_TYPES } from '@atlassian/jira-polaris-domain-field/src/field-types/index.tsx';
import {
	GENERIC_FIELD_FILTER,
	type FieldValueFilter,
} from '@atlassian/jira-polaris-domain-view/src/filter/types.tsx';

export const getIssueTypeNameFromGroupFilter = (
	groupFilter: FieldValueFilter<typeof ISSUETYPE_FIELDKEY, typeof FIELD_TYPES.ISSUE_TYPE>,
) => {
	if (groupFilter?.type !== GENERIC_FIELD_FILTER) {
		return undefined;
	}

	if (groupFilter.field !== ISSUETYPE_FIELDKEY) {
		return undefined;
	}

	if (groupFilter.values.length === 0) {
		return undefined;
	}

	if (groupFilter.values[0].stringValue === undefined) {
		return undefined;
	}

	return groupFilter.values[0].stringValue;
};

export const createGroupFilterFromIssueTypeName = (
	issueTypeName: string,
): FieldValueFilter<typeof ISSUETYPE_FIELDKEY, typeof FIELD_TYPES.ISSUE_TYPE> => ({
	type: GENERIC_FIELD_FILTER,
	field: ISSUETYPE_FIELDKEY,
	fieldType: FIELD_TYPES.ISSUE_TYPE,
	values: [{ stringValue: issueTypeName }],
});
